import styled from 'styled-components'

export const SidebarBtnDelete = styled.button`
  cursor: pointer;
  outline: none;
  border: none;
  background: none;
  color: #f15025;
  font-size: 14px;
  transition: all 0.5s ease-in-out;
  margin-right: 10px;
  margin-left: 10px;

  :hover {
      color: #000;
  }
`